import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TestModeService } from '../services/test-mode';

/**
 * Stamps EVERY API request with the Live/Test data view (X-Data-View: live|test) from the
 * topbar toggle. The backend's list and search queries filter on it, so test enrolments can
 * never leak into a live list — and a live record never shows while browsing test data.
 * Callers that don't send the header (partner app, client portal, integrations) default to
 * live on the server.
 */
export const dataViewInterceptor: HttpInterceptorFn = (req, next) => {
  if (isPlatformBrowser(inject(PLATFORM_ID))) {
    const view = inject(TestModeService).viewTest() ? 'test' : 'live';
    req = req.clone({ setHeaders: { 'X-Data-View': view } });
  }
  return next(req);
};
